import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Header from 'components/Header/Header';
import Footer from 'components/Footer';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
// import Bubble from 'components/UI/Bubble';
import BlockTitle from 'components/UI/BlockTitle';
// import BlockButton from 'components/UI/BlockButton';
import HelpSpeedTest from 'components/Help/HelpSpeedTest';
import Template from 'components/Template/Template';
import Faq from 'components/UI/Faq';
import i18n from 'helpers/i18n';
import { getCurrentUserRole } from 'ducks/authentication';
import Paper from '@material-ui/core/Paper';
import Banner from 'components/Banner/Banner';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Fade from '@material-ui/core/Fade';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      height: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 200,
      },
    },
    content: {
      height: 'calc(100% - 150px - 120px)',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    paperWrapper: {
      width: '100%',
      display: 'block',
    },
    paper: {
      padding: theme.spacing(4),
    },
    helpSpeedTest: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(2),
      textAlign: 'center',
    },
  };
};

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // answerVisible: null,
      // speedTestPopin: false,
      // contactPopin: false
    };
  }

  render() {
    const { onPanelToggle, userRole, classes } = this.props;

    const isAdmin = userRole === 'admin';

    const direction = process.env.REACT_APP_SITE === 'hemato' ? 'horizontal' : 'vertical'

    return (
      <Template current={'help'} headerImage="background" fixedSizeThreshold={960}>
        <Fade in timeout={1000}>
          <Box className={classes.paperWrapper}>
            <Paper square elevation={0} className={classes.paper}>
              <Typography variant="h3">{i18n.get('helpTitle')}</Typography>
              <Grid container>
                <Grid item xs={12}>
                  <Faq isAdmin={isAdmin} userRole={userRole} forceOpen={true} direction={direction}/>
                </Grid>
                <Grid item xs={12}>
                  <HelpSpeedTest className={classes.helpSpeedTest} />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Help));



// WEBPACK FOOTER //
// ./src/components/Help/Help.jsx